export default __webpack_public_path__ + "static/media/xbox-2.061a9c40.png";